import { render, staticRenderFns } from "./MemberPurposeViewerComponent.vue?vue&type=template&id=6b2a462c&"
import script from "./MemberPurposeViewerComponent.vue?vue&type=script&lang=js&"
export * from "./MemberPurposeViewerComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports